import { useRouter } from 'next/router';

import { useTranslation } from 'react-i18next';

import { Button } from '@basic';
import { UIPaths } from '@consts';
import { SearchIcon } from '@icons';
import classNames from 'classnames';
function NoStreamsPlaceholder({ streamIsActive }: { streamIsActive: boolean }) {
  const { t } = useTranslation();
  const router = useRouter();

  return (
    <div
      className={classNames(
        'flex flex-col items-center justify-end gap-xl w-full pb-[120px]',
        'dk:pb-0'
      )}
    >
      <div className={classNames('w-screen dk:w-full dk:max-w-screen-xl')}>
        <svg
          width='100%'
          height='100%'
          viewBox='0 0 390 265'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            d='M143.79 28C143.79 38.2173 135.107 46.5 124.395 46.5C113.684 46.5 105 38.2173 105 28C105 17.7827 113.684 9.5 124.395 9.5C135.107 9.5 143.79 17.7827 143.79 28Z'
            fill='#FFBB53'
          />
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M181.742 225.83C197.566 225.83 210.394 213.594 210.394 198.5C210.394 183.406 197.566 171.17 181.742 171.17C165.918 171.17 153.09 183.406 153.09 198.5C153.09 213.594 165.918 225.83 181.742 225.83ZM181.742 234.5C202.586 234.5 219.484 218.382 219.484 198.5C219.484 178.618 202.586 162.5 181.742 162.5C160.898 162.5 144 178.618 144 198.5C144 218.382 160.898 234.5 181.742 234.5Z'
            fill='#E04E4E'
          />
          <path
            d='M0 198.5C30.3757 198.5 55 175.219 55 146.5C55 117.781 30.3757 94.5 9.09197e-06 94.5L0 198.5Z'
            fill='#FF7236'
          />
          <path
            d='M390.157 38.4187C344.54 43.2478 308.999 81.8436 308.999 128.741C308.999 175.637 344.54 214.233 390.157 219.062V248.001C328.602 243.076 280.185 191.562 280.185 128.741C280.185 65.9186 328.602 14.4052 390.157 9.48047V38.4187Z'
            fill='#8348CF'
          />
        </svg>
      </div>
      {!streamIsActive && (
        <div className={classNames('fixed bottom-[100px] dk:bottom-[50px]')}>
          <Button size='large' type='primary' onClick={() => router.push(UIPaths.explore())}>
            <div className='flex flex-row items-center justify-center gap-xs'>
              <SearchIcon size={20} />
              <div>{t('components.placeholderNoStreams.exploreGoalsButton.text')}</div>
            </div>
          </Button>
        </div>
      )}
    </div>
  );
}

export default NoStreamsPlaceholder;
